<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><rect width="10" height="10" rx="1" style="fill:#2c59d9" transform="translate(3 3)"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-control-stop',
});
</script>
